import { proposalsService } from '@/services/proposals';
import type {
  InitiateProposalPayload,
  InitiateProposalResponse,
} from '@/services/proposals/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useInitiateProposal() {
  const queryClient = useQueryClient();

  return useMutation<InitiateProposalResponse, Error, InitiateProposalPayload>({
    mutationKey: ['proposals', 'initiate'],
    mutationFn: async (payload) => {
      const response = await proposalsService.initiateProposal(payload);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao criar proposta');
      }

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['quotes'] });
      await queryClient.invalidateQueries({
        queryKey: ['quotes-status-count'],
      });
      await queryClient.invalidateQueries({ queryKey: ['proposals'] });
    },
  });
}
